import React, { useContext } from "react";
import { AdminAuctionContext } from "../context/AdminAuctionContext";
import GraphicalViewerMapProvider from "../context/GraphicalViewerMapContext";
import UploadGVImage from "../components/UploadGVImage";
import AuctionInactiveMessage from "../components/AuctionInactiveMessage";
import GraphicalViewerMap from "../components/GraphicalViewerMap";

export default function GraphicalViewerSetup() {
    const { currentAuctionIsLive, currentAuctionId } =
        useContext(AdminAuctionContext);

    let width = "100%";
    const canvas = document.querySelector("canvas");
    if (canvas) {
        width = canvas.clientWidth + 320 + 24 + "px";
    }

    return (
        <GraphicalViewerMapProvider>
            {!currentAuctionIsLive && <AuctionInactiveMessage />}
            <div className="flex justify-end mb-12 mr-12">
                <button
                    onClick={() => {
                        // Open as regular tab - fullscreen will be triggered from within the page
                        window.open(
                            `/admin/auction-interface/${currentAuctionId}/graphical-viewer`,
                            "_blank"
                        );
                    }}
                >
                    <div className="flex space-x-2">
                        <div>Open GV</div>
                        <div>
                            <svg
                                width="18"
                                height="18"
                                viewBox="0 0 22 22"
                                fill="#444"
                            >
                                <path d="M 5 3 C 3.9069372 3 3 3.9069372 3 5 L 3 19 C 3 20.093063 3.9069372 21 5 21 L 19 21 C 20.093063 21 21 20.093063 21 19 L 21 12 L 19 12 L 19 19 L 5 19 L 5 5 L 12 5 L 12 3 L 5 3 z M 14 3 L 14 5 L 17.585938 5 L 8.2929688 14.292969 L 9.7070312 15.707031 L 19 6.4140625 L 19 10 L 21 10 L 21 3 L 14 3 z"></path>
                            </svg>
                        </div>
                    </div>
                </button>
            </div>
            <div
                id="gv-setup-container"
                className="relative mx-auto flex justify-center"
                style={{ width: width }}
            >
                <UploadGVImage />
                <GraphicalViewerMap />
            </div>
        </GraphicalViewerMapProvider>
    );
}
